import "./map.css";
export default function Map() {
    return (
        <>
            <section class="map-one">
                <div class="map-outer">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.670634884603!2d72.5568284747706!3d23.035862515833177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84f76e6cf387%3A0xae763cdea897d53b!2sHorizon%20WebInfo%20Pvt%20Ltd%20%7C%20Odoo%20Developer%20%7C%20Custom%20ERP%20Software%20Ahmedabad!5e0!3m2!1sen!2sin!4v1763459858259!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </section>
        </>
    );
}